import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import SiteSearch from './SiteSearch';
import './Navbar.css';

const Navbar = ({ onOpenCart }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { totalCount } = useCart();
  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>
            <img src="/logo.png" alt="حمزة لقطع غيار مرسيدس" className="logo-img" />
            <span className="logo-text">حمزة</span>
          </Link>
          <div className="navbar-end-cluster">
          <div className="navbar-drawer-wrap">
          <div className={`navbar-drawer ${menuOpen ? 'open' : ''}`}>
            <div className="navbar-drawer-header">
              <span className="navbar-drawer-title">القائمة</span>
              <button
                type="button"
                className="navbar-drawer-close"
                onClick={() => setMenuOpen(false)}
                aria-label="إغلاق القائمة"
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <ul className="navbar-menu">
              <li>
                <Link to="/" onClick={() => setMenuOpen(false)} className="navbar-menu-link">
                  <i className="fas fa-home navbar-menu-icon" aria-hidden="true" />
                  <span>الرئيسية</span>
                </Link>
              </li>
              <li>
                <Link to="/#models-section" onClick={() => setMenuOpen(false)} className="navbar-menu-link">
                  <i className="fas fa-car navbar-menu-icon" aria-hidden="true" />
                  <span>الموديلات</span>
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={() => setMenuOpen(false)} className="navbar-menu-link">
                  <i className="fas fa-info-circle navbar-menu-icon" aria-hidden="true" />
                  <span>من نحن</span>
                </Link>
              </li>
            </ul>
          </div>
          </div>
          <div className="navbar-actions">
            <button
              type="button"
              className="navbar-toggle"
              aria-label="القائمة"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
            >
              <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'} />
            </button>
            {onOpenCart && (
              <button
                type="button"
                className="navbar-cart-btn"
                onClick={() => { setMenuOpen(false); onOpenCart(); }}
                aria-label="سلة الطلبات"
              >
                <i className="fas fa-shopping-cart" />
                {totalCount > 0 && <span className="navbar-cart-badge">{totalCount > 99 ? '99+' : totalCount}</span>}
              </button>
            )}
            <SiteSearch mode="icon" />
          </div>
          </div>
        </div>
      </div>
      <div className={`navbar-backdrop ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)} aria-hidden="true" />
    </nav>
  );
};

export default Navbar;
